import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="product-gallery"
export default class extends Controller {
  static targets = ["main", "thumb", "modal", "modalImage", "counter"]
  static values = { images: Array }

  connect() {
    this.currentIndex = 0
    this.onKeydown = this.onKeydown.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  select(event) {
    this.currentIndex = this.thumbTargets.indexOf(event.currentTarget)
    this.showCurrent()
  }

  next() {
    if (this.imagesValue.length < 2) return
    this.currentIndex = (this.currentIndex + 1) % this.imagesValue.length
    this.showCurrent()
  }

  previous() {
    if (this.imagesValue.length < 2) return
    this.currentIndex = (this.currentIndex - 1 + this.imagesValue.length) % this.imagesValue.length
    this.showCurrent()
  }

  showCurrent() {
    if (this.hasMainTarget && this.thumbTargets.length > 0) {
      this.mainTarget.src = this.thumbTargets[this.currentIndex].dataset.imageUrl
    }
    if (this.hasModalImageTarget) {
      this.modalImageTarget.src = this.imagesValue[this.currentIndex]
    }
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = `${this.currentIndex + 1} / ${this.imagesValue.length}`
    }
  }

  open() {
    this.showCurrent()
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.onKeydown)
  }

  close() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.onKeydown)
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }

  onKeydown(event) {
    if (event.key === "Escape") this.close()
    if (event.key === "ArrowLeft") this.previous()
    if (event.key === "ArrowRight") this.next()
  }
}
